// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminAuctionNotificationPreference = (client) => ({
    /**
     * `POST /admin/auction-notification-preference`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionNotificationPreferenceUpsert
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auction-notification-preference/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/auction-notification-preference", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/auction-notification-preference`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminAuctionNotificationPreferenceRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/admin/auction-notification-preference/route.ts
     */
    list: (query, headers) => client.fetch("/admin/auction-notification-preference", { method: "GET", query, headers }),
});
//# sourceMappingURL=auction-notification-preference.js.map